export default __webpack_public_path__ + "static/media/ValleyHuntingLodgeMap.db5ce36f.jpg";